import React from "react";
import { DiseaseKnowledgeSearchResult } from "./DiseaseKnowledgeSearchResult";
import { SearchTextField } from "../SearchTextField";

export const DiseaseKnowledgeSearchResultDialog = React.memo(function DiseaseKnowledgeSearchResultDialog() {
    return (
        <div className={"list_dialog"}>
            <div className={"container"}>
                <h2 className={"title"}>医療知識一覧</h2>
                <SearchTextField />
                <DiseaseKnowledgeSearchResult />
            </div>
        </div>
    );
});
